// import * as RULES from 'constant/form-rules'
import React from 'react'
import { Form, Input } from 'antd'
import PropTypes from 'prop-types'
import styles from '../styles.scss'

const URLInput = ({ disabled = false, name, title }) => {
  return (
    <>
      <span>{title}</span>
      <Form.Item
        disabled={disabled}
        name={name}
        // rules={[RULES.REQUIRED]}
      >
        <Input
          className={styles.form_input}
          disabled={disabled}
          placeholder={title}
        />
      </Form.Item>
    </>
  )
}

URLInput.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  title: PropTypes.string
}

export default URLInput
